export const parseParagraphs = (input: string): string =>
  `<p>${input.replace(/\n{2}/g, '</p><p>').replace(/[\n]/g, '<br />')}</p>`

export type GtmParams = {
  event?: string
  category: string
  action: string
  label?: string
}

export const gtm: (params: GtmParams) => void = (params: GtmParams) => {
  const defaultParams: GtmParams = {
    event: 'event.dubbeldam',
    category: '',
    action: '',
    label: window.location.pathname,
  }

  if (window.dataLayer) {
    window.dataLayer.push({ ...defaultParams, ...params })
  } else {
    console.log({ ...defaultParams, ...params })
  }
}

export const compareString: (a: string, b: string) => number = (a: string, b: string) => {
  return a < b ? -1 : a > b ? 1 : 0
}

export const sluggify: (str: string) => string = (str: string) => {
  let slug: string
  if (str) {
    slug = str.trim().toLowerCase().replace(/\'/gi, '').replace(/\s/gi, '-').replace(/\-\-/gi, '-')
  }
  return slug
}
